const initialState = {
  interlocutors: [],
  loading: false,
  error: null,
};

const interlocutorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "INTERLOCUTORS_LOADING":
      return { ...state, loading: true };
    case "INTERLOCUTORS_SUCCESS":
      return {
        ...state,
        loading: false,
        interlocutors: payload,
      };
    case "INTERLOCUTORS_ERROR":
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case "CLEAR_INTERLOCUTORS":
      return {
        ...state,
        interlocutors: [],
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default interlocutorReducer;
